<div class="container mt-5 pt-5">
    <div class="row">
        <div class="col-sm-12">
            <p>
                Estimado usuario,
                <br/>
                Su compra fue {{mensaje}} 
            </p>            

        </div>
    </div>
</div>